import Icon from "~/components/shared/Icon";
import { State, WaitStep } from "~/lib/pipeline";
import { WAIT_STEP_HEIGHT } from "~/components/build/Show/routes/list/-components/constants";
import { TreeNode } from "~/components/build/Show/routes/list/-components/TreeNode";
import {
  HoverCard,
  HoverCardTrigger,
  HoverCardContent,
  HoverCardPortal,
} from "~/components/shared/HoverCard";

interface Props {
  step: WaitStep;
}

export function WaitStepItem({ step }: Props) {
  return (
    <div className="flex h-full w-full items-center px-1.5">
      <div className="flex flex-1 items-center gap-2">
        <div className="flex-1 border-b border-gray-400" />
        <HoverCard openDelay={500} closeDelay={100}>
          <HoverCardTrigger asChild={true}>
            <span className="text-charcoal-300 hover:text-charcoal-800 flex items-center transition-colors">
              <Icon
                icon={
                  step.state === State.Finished
                    ? "heroicons/outline/chevron-down"
                    : "heroicons/solid/pause"
                }
                className="size-4 shrink-0"
              />
            </span>
          </HoverCardTrigger>
          <HoverCardPortal>
            <HoverCardContent className="z-50" hideArrow={true} size="max-sm" side="top">
              <p className="text-charcoal-600 m-0 text-xs font-medium">Wait</p>
            </HoverCardContent>
          </HoverCardPortal>
        </HoverCard>
        <div className="flex-1 border-b border-gray-400" />
      </div>
    </div>
  );
}

export const createWaitStepNode = (step: WaitStep): TreeNode => ({
  id: step.uuid,
  height: WAIT_STEP_HEIGHT,
  render: () => <WaitStepItem step={step} />,
});
